// transforms a stringified html into html
// the string should include a wrapper element
export default function stringToHtml (str) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(str, 'text/html');

  return doc.body.firstChild;
}
